import React, { useState, useEffect } from 'react';
import { certificateAPI } from '../api/certificateAPI';
import { withAppBasename } from '../../../config/appBase';
import './ProfileCertificatesSection.css';

export default function ProfileCertificatesSection({ userId }) {
  const [certificates, setCertificates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }
    let isMounted = true;
    certificateAPI
      .getUserCertificates(userId)
      .then((data) => {
        if (isMounted) {
          setCertificates(data || []);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error('Failed to load user certificates:', err);
        if (isMounted) setLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [userId]);

  if (loading) {
    return (
      <div className="profile-section">
        <div className="section-header">
          <h2>Certificates & Credentials</h2>
          <p>Official verified institutional credentials and programme certificates</p>
        </div>
        <div style={{ padding: '20px', textAlign: 'center', opacity: 0.6, fontFamily: 'JetBrains Mono, monospace', fontSize: '13px' }}>
          Loading credentials…
        </div>
      </div>
    );
  }

  if (!certificates || certificates.length === 0) {
    return null;
  }

  return (
    <div className="profile-section" data-tour="profile-certificates">
      <div className="section-header">
        <div className="section-header-info">
          <h2>Certificates & Credentials</h2>
          <p>Official verified institutional credentials and completed programme certificates</p>
        </div>
      </div>

      <div className="profile-certs-container">
        {certificates.map((cert) => {
          const displayIssuer = (!cert.issuer || cert.issuer.toLowerCase() === 'ivori for education' || cert.issuer.toLowerCase() === 'ivori edu')
            ? 'IVORI Edu'
            : cert.issuer;

          return (
            <div className="profile-cert-card" key={cert.id}>
              <div className="profile-cert-top">
                <div className="profile-cert-seal-icon" aria-hidden="true">
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                    <path d="M9 12l2 2 4-4" />
                  </svg>
                </div>
                <div className="profile-cert-info">
                  <div className="profile-cert-badge-row">
                    <h3 className="profile-cert-title">{cert.programme_name}</h3>
                    <span className="profile-cert-status-badge">
                      <span className="profile-cert-status-dot" />
                      Verified Active
                    </span>
                  </div>
                  <div className="profile-cert-meta">
                    <span className="profile-cert-id">ID: {cert.id}</span>
                    <span className="profile-cert-dot">·</span>
                    <span>Issued: {cert.issue_date}</span>
                    <span className="profile-cert-dot">·</span>
                    <span>Issuer: <strong>{displayIssuer}</strong></span>
                  </div>
                </div>
              </div>

              <div className="profile-cert-actions">
                <a
                  href={withAppBasename(cert.verification_url || `/verify/${cert.id}`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="profile-cert-btn profile-cert-btn-primary"
                >
                  View Credential
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
